import { CREATE_NOTIFICATION_MESSAGE } from '../constants';

// create a new notification message
export const doCreateNotificationMessage =
  ({ message, type = 'default' } = {}) =>
  async ({ dispatch }) => {
    dispatch({ payload: { message, type }, type: CREATE_NOTIFICATION_MESSAGE });
  };
